import { useEffect, useRef } from 'react';

/**
 * A profile opened in edit mode (?mode=edit, old Edit links) lands on a tile
 * the role may change: the requested one if it can, otherwise the first one
 * that can; with none, the profile opens for viewing.
 *
 * @param {Object} params
 * @param {boolean} params.editing
 * @param {(on: boolean) => void} params.setEditing
 * @param {string[]} params.tiles - visible tiles in display order; empty while loading
 * @param {string} params.activeTile
 * @param {(id: string) => boolean} params.canEditTile
 * @param {(id: string) => void} params.setSelected
 */
export default function useEditLanding({
  editing,
  setEditing,
  tiles,
  activeTile,
  canEditTile,
  setSelected,
}) {
  const landed = useRef(false);

  useEffect(() => {
    if (landed.current || !tiles.length) return;
    landed.current = true;
    if (!editing || canEditTile(activeTile)) return;
    const first = tiles.find(canEditTile);
    if (first) setSelected(first);
    else setEditing(false);
  }, [editing, setEditing, tiles, activeTile, canEditTile, setSelected]);
}
